import { createClient } from 'contentful'

export const client = createClient({
    space: 'aizmd287orvl',
    accessToken: 'bUO1xI5_Ej6eMG5W6sYbJmJEk74ust-RJPFgVTNjK5c',
    environment: 'master',
})

export const getEntry = async (id: string | string[] | undefined) => {
    try {
        const client = createClient({
            space: 'aizmd287orvl',
            environment: 'master',
            accessToken: 'bUO1xI5_Ej6eMG5W6sYbJmJEk74ust-RJPFgVTNjK5c',
        })

        return await client.getEntry(`${id}`)
    } catch (error) {
        console.error(error)
        throw error
    }
}

export const clientVacant = createClient({
    space: 'koyi6kkwzxt3',
    accessToken: '_05KCsSx-C-SaOsicIe09Hp2Lf-qvhfamgRMCbVZwXE',
    environment: 'master',
})
export const getWere = async (id: string | string[] | undefined) => {
    try {
        const client = createClient({
            space: 'koyi6kkwzxt3',
            environment: 'master',
            accessToken: '_05KCsSx-C-SaOsicIe09Hp2Lf-qvhfamgRMCbVZwXE',
        })

        return await client.getEntry(`${id}`)
    } catch (error) {
        console.error(error)
        throw error
    }
}
